import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import UserService from '@/services/UserService';
import {
  updateProfile,
  uploadProfilePicture,
} from '@/store/slices/components/userProfile/services';

export const updateUserDataAsync = createAsyncThunk(
  'user-data/updateUserDataAsync',
  async () => {
    const data = await UserService.getUserMeData();
    return data;
  }
);

const initialState = {
  data: false,
  themeConfig: {
    theme: '',
    crmName: '',
    faviconPath: '',
    chatName: '',
  },
};

export const UserSlice = createSlice({
  name: 'user-data',
  initialState,
  reducers: {
    setUserState(state, action) {
      state = action.payload.user_data;
    },
    setThemeSettings(state, action) {
      const { theme } = action.payload;

      if (theme === 'univen') {
        state.themeConfig.theme = 'univen';
        state.themeConfig.crmName = 'Univen';
        state.themeConfig.faviconPath = '/univen-favicon-32x32.png';
        state.themeConfig.chatName = 'Univen Chat';
      } else {
        state.themeConfig.theme = 'tokkobroker';
        state.themeConfig.crmName = 'Tokko Broker';
        state.themeConfig.faviconPath = '/favicon-tokko.ico';
        state.themeConfig.chatName = 'Tokko Chat';
      }
    },
    setUpdatePhone(state, action) {
      const { cellphone } = action.payload;
      if (state.data.branch) {
        state.data.branch = {
          ...state.data.branch,
          cellphone,
        };
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateUserDataAsync.fulfilled, (state, action) => {
      state.data = { ...action.payload.user_data };

      if (typeof window !== 'undefined' && window.userGuiding) {
        const { user_data } = action.payload;
        window.userGuiding.identify(String(user_data.id), {
          email: user_data.email,
          name: user_data.name,
          created_since: user_data.created_since,
          user_type: user_data.user_type,
          is_company_owner: user_data.is_company_owner,
          valid_email: user_data.valid_email,
          status: user_data.status,
          company_id: String(user_data.company_id),
          edited_logo: user_data.company_logo,
          lenguaje: user_data.user_language,
        });
      }

      // set lagugage to local storage
      localStorage.setItem(
        'user_language',
        action.payload.user_data.user_language
      );

      localStorage.setItem(
        'company_language',
        action.payload.user_data.company_language
      );
    });
    // The header and messenger read the avatar from here, not from the profile.
    builder.addCase(uploadProfilePicture.fulfilled, (state, action) => {
      if (!state.data) return;
      state.data.profile_photo = action.payload.profile_picture_url;
    });
    // Same for the name. Profile saves are queued, so they resolve in order.
    // first_name is derived like the backend does: the first word.
    builder.addCase(updateProfile.fulfilled, (state, action) => {
      const { id, full_name: fullName } = action.payload;
      if (!state.data || state.data.id !== id) return;
      const [firstName] = fullName.split(' ');
      state.data.full_name = fullName;
      state.data.first_name = firstName;
    });
  },
});

export const { setUserState, setThemeSettings, setUpdatePhone } =
  UserSlice.actions;

export const selectUserState = (state) => state.UserSlice;

export default UserSlice.reducer;
